import { Controller } from "@hotwired/stimulus"

// The membership landing page's announcement bar sticks just below the sticky
// site header, whose height changes with the viewport (the utility bar wraps,
// the nav collapses), so the offset is measured rather than hard-coded.
export default class extends Controller {
  static values = { headerSelector: String }

  connect() {
    this.header = this.headerSelectorValue ? document.querySelector(this.headerSelectorValue) : null
    this.measure = this.measure.bind(this)
    this.measure()

    if (this.header && "ResizeObserver" in window) {
      this.resizeObserver = new ResizeObserver(this.measure)
      this.resizeObserver.observe(this.header)
    }
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  measure() {
    const offset = this.header ? this.header.getBoundingClientRect().height : 0
    this.element.style.setProperty("--ms-announcement-top", `${offset}px`)
  }

  dismiss() {
    this.element.hidden = true
  }
}
